import { FormSetupState } from '../types';

export const initialState: FormSetupState = {
  workOrder: null,
  jobSite: null,
};
